angular
    .module("skillBuilderSaaS")
    .directive("modalSize", function () {
    return {
        restrict: "A",
        link: function (_scope, element, $attrs) {
            $(element).parents(".modal-dialog").removeClass("modal-md").addClass("modal-" + $attrs.modalSize);
        }
    };
});
